import { URL } from '../../config.js';
import {axios} from '../../handlers/RequestHandler';
import store from '../store';
import {  OLDtableUpdate ,OLDtableRemove} from './tableActions';
import Notification from '../../handlers/Notification';
import {
	NUMBER_REGEX,
	TXT_REGEX,
	EMAIL_REGEX,
    TXT_REGEX_MIN4
} from '../../constants/general';

const findForm = (type,isBranch) => {
    return (dispatch,getState) => {
        return axios.get(`${URL + getState().company.id}${isBranch ? `/branches/${ getState().branch.id}` : `` }/forms/${type}`).then( (res) => {
			// TODO: currency no viene de aqui? en company no pero en forms no se...
            dispatch({
                type: 'GET_FORM',
                form: {
                    answers:res.data.data,
                    name:res.data.name,
                    icon:res.data && res.data.icon ? res.data.icon : 0,
                    currency:{
                        iso:res.data && res.data.currency && res.data.currency.iso ? res.data.currency.iso : getState().company.currency_iso,
                        tax_flat_e2:res.data && res.data.currency && res.data.currency.tax_flat_e2 ? res.data.currency.tax_flat_e2/100 :0,
                        tax_percent:res.data && res.data.currency && res.data.currency.tax_percent ? res.data.currency.tax_percent*100 :0
                    },
                    internal_name: res.data.internal_name
                },
            });

        }).catch((err) => {
            if (type === 1){
                if (err.status === 404){
                    //no imprimir nada!
                } else if(err.message && err.message !== 'generic')
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
                else
                    Notification.show({type: "error", title:  err.title, msg: getState().json_lang.custom_errors.retrieving_proof_of_delivery });
            } else {
                if(err.message && err.message !== 'generic')
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
                else
                    Notification.show({type: "error", title:  err.title, msg: getState().json_lang.custom_errors.retrieving_forms_list});
            }
        });
    }
}

const getForms = () => {
	return (dispatch) => {
	    return axios.get(URL + store.getState().company.id + '/forms').then( (res) => {

	    }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:  err.title, msg: store.getState().json_lang.custom_errors.retrieving_forms_list});
	    });
	}
}

const storeForm =(type,isBranch) =>{
    return (dispatch,getState) => {
        
        let form = getState().form
        
        let storeUrl = `${URL + getState().company.id}${isBranch ? `/branches/${ getState().branch.id}` : `` }/forms/${type ? type:`payment` }`
        let actionUrl = type ? `put`:`post` 
        let questions = form.answers.filter( (form,key) => {
            if(form.option){
                let noEmptyChoise = form.option.choices.filter( (choice,key) => {
                    return (choice !=="" )
                })
                form.option.choices = noEmptyChoise
            }
            if(form.file){
                form.file.allowed_types =["image/jpeg", "image/png", "application/pdf"]
            }
            return (form )
        })
        form.answers=questions
        form={
            form:questions,
            name:form.name,
            icon:form.icon,
            internal_name: form.internal_name ? form.internal_name : null,
            type:form.type,
            currency:{
                iso: form.currency && form.currency.iso ? form.currency.iso : getState().currencies.local.iso,
                tax_flat_e2: form.currency && form.currency.tax_flat_e2 ? form.currency.tax_flat_e2*100 :0,
                tax_percent: form.currency && form.currency.tax_percent ? form.currency.tax_percent/100 :0
            }
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios[actionUrl](storeUrl, form).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});

            dispatch({
                type: 'FORM_UPDATE_SUCCESS',
                table: OLDtableUpdate(res),
                preloader:false
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:  err.title, msg: getState().json_lang.custom_errors.form_update_failed});
        });
    } 
}

const storeProofDeliverySettings = () =>{
    return (dispatch,getState) => {
        var form = getState().form
        form.name="ProofDelivery";
        var questions = form.answers.filter( (form,key) => {
            if(form.option){
                var noEmptyChoise = form.option.choices.filter( (choice,key) => {
                    return (choice !=="" )
                })
                form.option.choices = noEmptyChoise
            }
            if(form.file){
                form.file.allowed_types =["image/jpeg", "image/png", "application/pdf"]
            }
            return (form )
        })
        form.answers=questions
        form={
            form:questions,
            name:form.name,
            icon:form.icon
        }
        return axios.put(URL + getState().company.id + '/forms/1', form).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful});
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:  err.title, msg: getState().json_lang.custom_errors.form_registration_failed});
        });
    }
}

const EnableDisableForm = (id,action,isBranch) => {
    return (dispatch,getState) => {
        var form = getState().form.answers
        dispatch({type: "WAIT_FOR_RESPONSE"})

        return axios.patch(`${URL + getState().company.id}${isBranch ? `/branches/${ getState().branch.id}` : `` }/forms/${id}/${action}`, form).then( (res) => {
            var succesful = getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:getState().json_lang.custom_success.update_successful});

            dispatch({
                type: 'FORM_UPDATE_SUCCESS',
                table: OLDtableUpdate(res),
                preloader:false
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:  err.title, msg: getState().json_lang.custom_errors.form_update_failed});
        });
    }
}

const DeleteForm = (id,isBranch) => {
    return (dispatch,getState) => {
        var form = getState().form.answers
        
        axios.delete(`${URL+getState().company.id}${isBranch ? `/branches/${ getState().branch.id}` : `` }/forms/${id}`, form).then( (res) => {
            var succesful = getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:getState().json_lang.custom_success.update_successful});
            dispatch({
                type: 'FORM_UPDATE_SUCCESS',
                table: OLDtableRemove(res),
                preloader:false
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:  err.title, msg: getState().json_lang.custom_errors.form_delete_failed});
        });
    }
}

const toggleData = (value) => {
	var name = value.name.split('-')[0];
	var id = parseInt(value.name.split('-')[1],10);
    return (dispatch,getState) => {
        var data = { ...getState().form }
        if(value.name === 'name' || value.name === 'icon' || value.name === 'internal_name' ){
            value.name === 'internal_name' && value.data === 'Seleccione' ? data[value.name] = null : data[value.name] = value.data
        }else if(value.name.split('-')[0] === 'currency'){
            if(!data.currency){data.currency={iso:'',tax_flat_e2:0,tax_percent:0}}
            data.currency[value.name.split('currency-')[1]] = value.data;
        }else{
            var update = data.answers.map( (answer,i) => {
                var getType = Object.getOwnPropertyNames(answer)[0]
                
                if( answer.option && answer.option.choices.indexOf(value.data)  === -1 && i === 0 && data.icon === 1){                  
                    answer.option.choices.push(value.data)
                }   
                
                if(answer[getType] && i === id){ 
                    if(name === 'choices'){
                        var choicesKey=parseInt(value.name.split('-')[2],10);
                        var updatechoise = answer.option.choices.map( (choice,index) => {
                            return index === choicesKey ? choice = value.data : (choice)
                        })
                        answer.option.choices = updatechoise
                    }else if(name === 'required'){
                        answer[getType].required = value.checked === true ? true:false;
                    }else{
                        answer[getType][name] = value.data
                    }
                }
                return (answer)
            })
            data.answers = update
        }

		dispatch({
		    type: 'FORM_TYPE',
		    form: data
		})
    }
}

const additemOption = (index,i) => {
    return (dispatch,getState) => {
        var itemsCont= getState().form.answers[i].option.choices.length
        if((parseInt(index,10)+1) ===itemsCont){
            getState().form.answers[i].option.choices.push("")
        }
    }
}

const additem = (item) => {
    return (dispatch,getState) => {
        var data ={...getState().form}
        var answer=''
        if(item === 'boolean'){
            answer={
                boolean:{
                    question:'',
                    required:false,
                }
            }
		}else if(item === 'input'){
			answer={
				input:{
					question:'',
					required:false,
					hint:'',
					regex:''
				}
			}
        }else if(item === 'option'){
            answer={
                option:{
                    question:'',
                    required:false,
                    choices:['']
                }
            }
        }else if(item === 'file'){
            answer={
                file:{
                    question:'',
                    required:false,
                }
            }
        }else if(item === 'text_button'){
            answer={
                text_button:{
                    question:'',
                    content:'',
                    button_text:'',
                    button_content:'',
                }
            }
        }else{
            answer={
                text:{
                    question:'',
                    content:'',
                }
            }
        }
        if(item){
            data.answers.push(answer);
            dispatch({
                type: 'FORM_TYPE',
                form: data
            })
        }
    }
}


const addDefaultForm = (form) => {

    const DEFAULT = 0;
    const TRANSFERENCIA_BANCARIA = 1;
    const PAGO_MOVIL = 2;
    //const PAGO_EFECTIVO = 3;
    const ZELLE = 4;
    const PAYPAL = 5;
    const INSTORE = 6;
    const RESERVE = 7;
    const BINANCE = 8;
    const HUMANIZ = 9;
    
    var answers=[];

    return (dispatch,getState) => {
        var data ={ ...getState().form };
        var intForm = parseInt(form,10)
        if(intForm === PAGO_MOVIL){
            data.name ='Pago Móvil'
            answers=[
                {
                    text:{
                        question:'Datos para hacer el pago',
                        content:'',
                    }
                },
                {
                    input:{
                        question:getState().json_lang.common.operacion_number,
                        required:true,
                        hint:'0000000',
                        regex:TXT_REGEX_MIN4,
                        type:'numeric'
                    },
                }
            ]
        }else if( intForm === TRANSFERENCIA_BANCARIA){
            data.name = getState().json_lang.common.wire_transfer;
            answers=[
                {
                    text:{
                        question:'Datos para hacer el pago',
                        content:'',
                    }
                },
                /*{
                    option:{
                        question:getState().json_lang.common.banks_select,
                        required:true,
                        choices:[getState().json_lang.common.same, getState().json_lang.create_order.delivery_method_other],
                        type:'bank'
                    },
                },*/
                {
                    input:{
                        question:getState().json_lang.common.operacion_number,
                        required:true,
                        hint:'00000000',
                        regex:TXT_REGEX_MIN4,
                        type:'numeric'
                    },
                },
                /*{
                    option:{
                        question:getState().json_lang.common.banks_transfer,
                        required:true,
                        choices:[getState().json_lang.common.same, getState().json_lang.create_order.delivery_method_other],
                        type:'bank'
                    }
                },*/
                /*{
                    file:{
                        question:getState().json_lang.common.screenshot,
                        required:true,
                        type:'file'
                    },
                },
                {
                    input:{
                        question:getState().json_lang.common.description,
                        required:false,
                        hint:'Observación',
                        regex:TXT_REGEX,
                        type:'text_area'
                    }
                }*/
            ]
        }else if( intForm === ZELLE){
            data.name ='ZELLE'
            answers=[
                {
                    input:{
                        question:`${getState().json_lang.tooltips.name}`,
                        required:true,
                        hint:'Nombre y apellido',
                        regex:TXT_REGEX,
                        type:'text'
                    },
                },
                {
                    input:{
                        question:getState().json_lang.common.email,
                        required:true,
                        hint:'Email@Email.com',
                        regex:EMAIL_REGEX,
                        type:'text'
                    },
                },
                {
                    input:{
                        question:getState().json_lang.common.confirmation_number,
                        required:true,
                        hint:'00000000',
                        regex:TXT_REGEX_MIN4,
                        type:'numeric'
                    },
                },
                {
                    input:{
                        question:getState().json_lang.common.last_digits_issuing_account,
                        required:true,
                        hint:'1234',
                        regex:NUMBER_REGEX,
                        type:'numeric'
                    }
                },
                {
                    file:{
                        question:getState().json_lang.common.screenshot,
                        required:true,
                        type:'file'
                    },
                }
            ]
        }else if(intForm === INSTORE){
            data.name ='Pago en tienda'
            answers=[
                {
                    option:{
                        question:getState().json_lang.common.payment_type,
                        required:true,
                        choices:[getState().json_lang.common.cash,getState().json_lang.common.point_of_sale],
                    },
                }
            ]
        }else if( intForm === RESERVE){
            data.name ='Reserve'
            answers=[
                {
                    text:{
                        question:'Usuario del comercio',
                        content:'',
                    }
                },
                {
                    input:{
                        question:'# de transacción',
                        required:true,
                        hint:'Código',
                        regex:TXT_REGEX_MIN4,
                        content:'',
                        type:'text',
                    }
                },
                {
                    input:{
                        question:'¿Quién envia el pago?',
                        required:true,
                        hint:'Coloca tu usuario de Reserve',
                        regex:TXT_REGEX,
                        type:'text'
                    },
                }
            ]
        } else if (intForm === HUMANIZ) {
            data.name ='Humaniz'
            answers=[
                {
                    text:{
                        question:'Datos del comercio',
                        content:'',
                    }
                },
                {
                    input:{
                        question:'# de transacción',
                        required:true,
                        hint:'Código',
                        regex:TXT_REGEX_MIN4,
                        content:'',
                        type:'text',
                    }
                },
                {
                    input:{
                        question:'¿Quién envia el pago?',
                        required:true,
                        hint:'Coloca tu usuario de Humaniz',
                        regex:TXT_REGEX,
                        type:'text'
                    },
                }
            ]
        }else if( intForm === BINANCE){
        
            data.name ='Binance'
            answers=[
                {
                    text:{
                        question:'Usuario del comercio',
                        content:'',
                    }
                },
                {
                    input:{
                        question:'# de transacción',
                        required:true,
                        hint:'Código',
                        regex:TXT_REGEX_MIN4,
                        content:'',
                        type:'text',
                    }
                },
                {
                    input:{
                        question:'¿Quién envia el pago?',
                        required:true,
                        hint:'Coloca tu usuario de Binance',
                        regex:TXT_REGEX,
                        type:'text'
                    },
                }
            ]
        }else if( intForm === PAYPAL){
            data.name ='Paypal';
            answers=[
                {
                    text:{
                        question:'Usuario del comercio',
                        content:'',
                    }
                },
                {
                    input:{
                        question:'# de transacción',
                        required:true,
                        hint:'Código',
                        regex:TXT_REGEX_MIN4,
                        content:'',
                        type:'text',
                    }
                },
                {
                    input:{
                        question:'¿Quién envia el pago?',
                        required:true,
                        hint:'Coloca tu usuario de Paypal',
                        regex:EMAIL_REGEX,
                        type:'text'
                    },
                }
        ]
        }else if( intForm === DEFAULT){
            data.name ='';
            answers=[]
        }
        data.answers = answers;
        data.icon = intForm;
        dispatch({
            type: 'FORM_TYPE',
            form: data
        })
    }
}

const removeitem = (key) => {
    return (dispatch,getState) => {
        var update = getState().form.answers.filter( (item,index) => {
            return index !== key;
        })
        var newdata = {
            ...getState().form
        }
        newdata.answers = update;
        dispatch({
            type: 'FORM_TYPE',
            form: newdata
        })
    }
}


const clearForm= () => {
    return (dispatch) => {
        dispatch({
            type: 'GET_FORM',
            form: {answers:[]},
        });
    }
}

/////////////////////////////cancelation reazons

const findCancelationReasons = (type='admin') => {
    return (dispatch) => {
        let path = type === 'admin' ? '/cancellation-reasons?limit=0' : '/client-cancellation-reasons?limit=0';
        
        return axios.get(URL + store.getState().company.id + path).then( (res) => {
            dispatch({
                type: 'GET_CANCELATION_REASONS',
                cancelationReasons: res.data,
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:  err.title, msg:store.getState().json_lang.custom_errors.form_delete_failed});
        });
    }
}

const createCancelationReason = (type='admin') => {
    var data={reason :store.getState().newCancelationReason}
    return (dispatch) => {

        let path = type === 'admin' ? '/cancellation-reasons' : '/client-cancellation-reasons';

        axios.post(URL + store.getState().company.id + path,data).then( (res) => {
            var succesful = store.getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:store.getState().json_lang.custom_success.saved_successful});

            dispatch({
                type: 'UPDATE_CANCELATION_REASONS',
                cancelationReasons: store.getState().cancelationReasons.concat(res.data),
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:store.getState().json_lang.custom_errors.cancelation_reason_registration_failed});
        });
    }
}

const updateCancelationReason = (id,data,type='admin') => {
    var newreason={reason :data}
    return (dispatch) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let path = type === 'admin' ? '/cancellation-reasons' : '/client-cancellation-reasons';
        axios.patch(URL + store.getState().company.id + path + '/' + id,newreason).then( (res) => {
            var cancelationReasons=store.getState().cancelationReasons.map( (cancelationReason) => {
                if(cancelationReason.id===parseInt(res.data.id,10)){
                   cancelationReason.reason = res.data.reason;
                }
                return cancelationReason;
            })

            var succesful = store.getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:store.getState().json_lang.custom_success.update_successful});

            dispatch({
                type: 'UPDATE_CANCELATION_REASONS',
                cancelationReasons: cancelationReasons,
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:store.getState().json_lang.custom_errors.cancelation_reason_update_failed});
        });
    }
}

const deleteCancelationReason = (id,type='admin') => {
    return (dispatch) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let path = type === 'admin' ? '/cancellation-reasons' : '/client-cancellation-reasons';
        axios.delete(URL + store.getState().company.id + path + '/' + id).then( (res) => {
            var cancelationReasons=store.getState().cancelationReasons.filter( (cancelationReason) => {
                return (cancelationReason.id!==parseInt(res.data.id,10))
            })

            var succesful = store.getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:store.getState().json_lang.custom_success.delete_successful});

            dispatch({
                type: 'UPDATE_CANCELATION_REASONS',
                cancelationReasons: cancelationReasons
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:store.getState().json_lang.custom_errors.cancelation_reason_delete_failed});
        });
    }
}

const toggleCancelationReason = (value) => {
    return (dispatch) => {
        var name=value.name.split('-')?value.name.split('-'):undefined
        if(name[0] === 'cancelReason'){
            var cancelationReasons=store.getState().cancelationReasons.map( (cancelationReason,key) => {
                if(key===parseInt(name[1],10)){
                   cancelationReason.reason = value.data;
                }
                return cancelationReason;
            })
            dispatch({
                type: 'GET_CANCELATION_REASONS',
                cancelationReasons: cancelationReasons
            })
        }else{
            var data = store.getState().newCancelationReason = value.data;
            dispatch({
                type: 'CANCELATION_REASON',
                newCancelationReason: data
            })
        }
    }
}

const getAllPayment = (page=1,sort,search_query = "") => { //&portal=ilike paypal
    return async (dispatch,getState) => {
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        const { company, branch } = getState();

        /* options=flag 15,15& */

        // let url_host = `/payments?desc&options=flag 15,15&order-status=flag 1015808,163840&limit=10&with=branch&page=${page}${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}`;
        let url_host = `/payments?limit=40&with=branch&page=${page}${
            sort ? `&sort_by=${sort.columnName},${sort.direction}` : ``
        }`;
        if (branch.id) {
            url_host = `/branches/${
                branch.id
            }/payments?limit=40&with=branch&page=${page}${
                sort ? `&sort_by=${sort.columnName},${sort.direction}` : ``
            }`;
        }
        url_host += search_query !== "" ? `&${search_query}` : "";
        return axios
            .get(URL + company.id + url_host)
            .then((res) => {
                dispatch({
                    type: "GET_ALL_PAYMENT",
                    allPayments: res.data,
                });
            })
            .catch((err) => {
                if (err.message)
                    Notification.show({
                        type: "error",
                        title: `Error ${
                            err && err.data && err.data.error_code
                        }`,
                        msg: err.message,
                    });
            });
    }
}

const getCompanyEarningsReport = (starDate, endDate) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
		const { company,branch } = getState();

        let url_host = `/earnings-report`;
        if(branch.id){
            url_host = `${url_host}?branch_id=${branch.id}`
        }

        if(starDate && endDate){
            url_host = `${url_host}${branch.id ? `&`:`?`}completed_at=between ${starDate},${endDate}`
        }
		return axios.get(`${URL + company.id+url_host}`).then( (res) => {
            dispatch({
                type: 'GET_COMPANY_EARNING',
                companyEarning:res.data
            });
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}
const getCompanyPaymentReport = (type, date) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
		const { company } = getState();
        if(type === 'today'){
            date = `?created_at=between ${date.startOf},${date.endOf}`
        }

        if(type === 'custom'){
            date = `?created_at=between ${date.startOf},${date.endOf}`
        }

        if(type === 'this_week'){
            date = `?created_at=between ${date.startOf},${date.endOf}`
        }

        if(type === 'this_month'){
            date = `?created_at=month ${date}`
        }
		return axios.get(`${URL + company.id}/payments-report${type ? date:``}`).then( (res) => {
            dispatch({
                type: 'GET_PAYMENT_REPORT',
                companyPayment:res.data
            });
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const getTodayPayment = (page=1,sort,startDate, endDate,queryString) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
		const { company } = getState();
        
        return axios.get(`${URL + company.id}/payments?limit=10&options=flag 15,15&with=branch&order-status=flag 1015808,163840&created_at=between ${startDate},${endDate}&page=${page}${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}${queryString ? `&${queryString}` :``}`).then( (res) => {
		//return axios.get(`${URL + company.id}/payments?sort_by=id,desc&limit=0&created_at=${date}&options=flag 15,15&order-status=flag 1015808,163840`).then( (res) => {
            dispatch({
                type: 'GET_ALL_PAYMENT',
                allPayments:res.data
            });
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const getWeekPayment = (page=1,sort,starDate, endDate,queryString) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
		const { company } = getState();

		return axios.get(`${URL + company.id}/payments?limit=10&page=${page}&options=flag 15,15&with=branch&order-status=flag 1015808,163840&created_at=between ${starDate},${endDate}${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}${queryString ? `&${queryString}` :``}`).then( (res) => {
            dispatch({
                type: 'GET_ALL_PAYMENT',
                allPayments:res.data
            });
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const getMonthPayment = (page=1,sort,month,queryString) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
		const { company } = getState();

		return axios.get(`${URL + company.id}/payments?limit=10&options=flag 15,15&with=branch&order-status=flag 1015808,163840&created_at=month ${month}&page=${page}${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}${queryString ? `&${queryString}` :``}`).then( (res) => {
            dispatch({
                type: 'GET_ALL_PAYMENT',
                allPayments:res.data
            });
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}


const getPayment = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL + getState().company.id}/payments/${id}`).then( (res) => {
            dispatch({
                type: 'GET_ONE_PAYMENT',
                onePayment:res.data
            });
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const acceptPayment = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(URL + getState().company.id + '/payments/'+id+'/accept').then( (res) => {
            var newPay={
                ...res.data,
                admin:{
                    display_name:getState().session.display_name
                }
            }

            var update = getState().payment_form.map( (item) => {
                if(item.id === res.data.id)
                   item = newPay;

                return item;
            })

            var succesful = getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:getState().json_lang.custom_success.saved_successful});

            dispatch({
                type: 'UPDATE_PAYMENT_FORM',
                payment_form:update
            });
        }).catch((err) => {
            if(err.message){
                if(err.data.error_code === "EC516"){
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: `Esta orden tiene pago automatizado, debe esperar al menos 5 minutos para poder validarlo manualmente.`});
                } else {
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
                }
            }
        });
    }
}


const clearPayment = () =>{
    return (dispatch) => {
        dispatch({
            type: 'GET_ONE_PAYMENT',
            onePayment:{}
        });
    }
}

const duplicatedPayment = (id) => {
    return (dispatch) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(URL + store.getState().company.id + '/payments/'+id+'/set-duplicated').then( (res) => {
           var newPay={
                ...res.data,
                admin:{
                    display_name:store.getState().session.display_name
                }
            }
            var update = store.getState().payment_form.map( (item) => {
                if(item.id === res.data.id)
                   item = newPay;

                return item;
            })

            var succesful = store.getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:store.getState().json_lang.custom_success.saved_successful});

            dispatch({
                type: 'UPDATE_PAYMENT_FORM',
                payment_form:update
            });
        }).catch((err) => {
            if(err.data){
                if(err.data.error_code === "EC516"){
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: `Esta orden tiene pago automatizado, debe esperar al menos 5 minutos para poder validarlo manualmente.`});
                } else {
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.description});
                }
            }
        });
    }
}

const invalidPayment = (id) => {
    return (dispatch) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(URL + store.getState().company.id + '/payments/'+id+'/set-invalid').then( (res) => {
            var newPay={
                ...res.data,
                admin:{
                    display_name:store.getState().session.display_name
                }
            }
            var update = store.getState().payment_form.map( (item) => {
                if(item.id === res.data.id)
                   item = newPay;

                return item;
            })
            var succesful = store.getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:store.getState().json_lang.custom_success.saved_successful});

            dispatch({
                type: 'UPDATE_PAYMENT_FORM',
                payment_form:update
            });
        }).catch((err) => {
            if(err.data){
                if(err.data.error_code === "EC516"){
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: `Esta orden tiene pago automatizado, debe esperar al menos 5 minutos para poder validarlo manualmente.`});
                } else {
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.description});
                }
            }
        });
    }
}

const refundPayment = (id, orderId, note) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        const { json_lang, company, session, payment_form, orderDetails } = getState();
         let adminNotes = { admin_notes: note }
        return axios.patch(`${URL}${company.id}/orders/${orderId}`, adminNotes).then((res) => {
            if(orderDetails){
                dispatch({
                    type: 'FETCH_ORDER_DETAILS',
                    orderDetails: {
                        ...orderDetails,
                        ...res.data
                    },
                })
            }
            return axios.patch(URL + company.id + '/payments/'+id+'/set-refunded').then( (res) => {
                var newPay={
                    ...res.data,
                    admin:{
                        display_name:session.display_name
                    }
                }
                var update = payment_form.map( (item) => {
                    if(item.id === res.data.id)
                       item = newPay;
    
                    return item;
                })
                var succesful = json_lang.common.success
                Notification.show({type: "success", title:succesful, msg:json_lang.custom_success.saved_successful});
    
                dispatch({
                    type: 'UPDATE_PAYMENT_FORM',
                    payment_form:update
                });
            }).catch((err) => {
                if(err.data){
                    if(err.data.error_code === "EC507"){
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: `Este método de pago no soporta acciones manuales.`});
                    } else {
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.description});
                    }
                } else {
                    Notification.show({type: "error", title:`Error`, msg: json_lang.two_steps_modal.default_error});
                }
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:err.title, msg:getState().json_lang.custom_errors.order_confirm});
        });
    }
}

const confirmCheckout = (id,qs) => {
    var data ={}

    qs.split('&').map( (query,i) => {
        var a = query.split('=')
        data[a[0].toLowerCase()] = a[1]
        return query
    })
    var param = {
        payerId: data.payerid
    }

    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(URL + getState().company.id + '/payments/'+id+'/charge',param).then( (res) => {
            dispatch({
                type: 'GET_PAYMENT_RESPONSE',
                paymentResponse:res.data && res.data.data
            });
        }).catch((err) => {
            dispatch({
                type: 'GET_PAYMENT_RESPONSE',
                paymentResponse:err.data
            });
        });
    }
}

export {
    getMonthPayment,
    getWeekPayment,
    getTodayPayment,
	getForms,
	toggleData,
	additem,
    additemOption,
	removeitem,
    DeleteForm,
    EnableDisableForm,
    findForm,
    clearForm,
    clearPayment,
    findCancelationReasons,
    createCancelationReason,
    toggleCancelationReason,
    deleteCancelationReason,
    updateCancelationReason,
    acceptPayment,
    duplicatedPayment,
    invalidPayment,
    refundPayment,
    confirmCheckout,
    storeProofDeliverySettings,
    addDefaultForm,
    getAllPayment,
    getPayment,
    storeForm,
    getCompanyEarningsReport,
    getCompanyPaymentReport
};


// WEBPACK FOOTER //
// ./src/store/actions/paymentActions.js